function getTranslateX(element) {
  var style = window.getComputedStyle(element);
  const transformArray = style.transform.match(/(-?[0-9\.]+)/g);
  return transformArray ? parseFloat(transformArray[4]) : 0;
}

function getWidth(element) {
  return parseFloat(window.getComputedStyle(element).width);
}

function getHeight(element) {
  return parseFloat(window.getComputedStyle(element).height);
}